import { render } from "./MastheadSection.vue?vue&type=template&id=70a9770b&scoped=true"
import script from "./MastheadSection.vue?vue&type=script&lang=js"
export * from "./MastheadSection.vue?vue&type=script&lang=js"

import "./MastheadSection.vue?vue&type=style&index=0&id=70a9770b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a9770b"]])

export default __exports__